export const projectsViewType = {
  NORMAL_PROJECTS: "active",
  ARCHIVED_PROJECTS: "archived",
  VIEW_GRID: "grid",
  VIEW_TABLE: "table",
};
